import { render, staticRenderFns } from "./zgfhxsc.vue?vue&type=template&id=728dab14&scoped=true&"
import script from "./zgfhxsc.vue?vue&type=script&lang=js&"
export * from "./zgfhxsc.vue?vue&type=script&lang=js&"
import style0 from "./zgfhxsc.vue?vue&type=style&index=0&id=728dab14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728dab14",
  null
  
)

export default component.exports